/**
 * Created by Mark on 06/04/2017.
 */


class ChatClient {

    constructor() {

    }

    toggleChatClient(){
        console.log('here');
        window.Tawk_API.toggle()
    }
}

export default ChatClient;


// WEBPACK FOOTER //
// ./src/classes/chat_client.js